



























import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import debounce from 'lodash/debounce';

@Component
export default class SButton extends Vue {
  @Prop(Boolean) public disabled?: boolean;
  @Prop(String) public icon?: string;
  @Prop(String) public classes?: string;
  @Prop({ type: String, default: 'standard' }) public color?: string;
  @Prop({ type: String, default: 'button' }) public type!: string;
  @Prop(Boolean) public isLoading?: boolean;

  @Ref() public buttonRef!: HTMLButtonElement;

  public focused = false;

  public click() {
    (this.$el as HTMLElement).click();
  }

  public focus() {
    this.buttonRef.focus();
  }

  private get onClick(): Function {
    const click = this.$listeners.click;
    if (typeof click === `object`) throw new Error("We don't know how to handle multiple click handler when it is an Array");
    if (typeof click !== `function`) return () => {};
    return debounce(args => (click as Function)(args), 200, { leading: true, maxWait: 200, trailing: false });
  }

  get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, click, ...listeners } = this.$listeners;
    return listeners;
  }

  get isLoaderWithoutIcon() {
    return this.isLoading && !this.hasIcon;
  }

  get buttonIcon() {
    return `${this.isLoading ? 'spinner' : (this.icon ? this.icon : '')}`;
  }

  get iconSpacer() {
    return this.hasSlot && this.hasIcon;
  }

  get hasIcon() {
    return !!this.icon;
  }

  get hasSlot() {
    return !!this.$slots.default;
  }

  public handleFocus() {
    this.focused = true;
  }

  public handleBlur() {
    this.focused = false;
  }
}
